var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvaliacaoTelemed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2681_27672)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 39.5,
    rx: 40,
    ry: 39.5,
    fill: "url(#paint0_linear_2681_27672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 48.6667L30 42L32.35 39.65L36.6667 43.95L47.65 32.9667L50 35.3333M40 25.3333C40.442 25.3333 40.8659 25.5089 41.1785 25.8215C41.4911 26.134 41.6667 26.558 41.6667 27C41.6667 27.442 41.4911 27.866 41.1785 28.1785C40.8659 28.4911 40.442 28.6667 40 28.6667C39.558 28.6667 39.134 28.4911 38.8215 28.1785C38.5089 27.866 38.3333 27.442 38.3333 27C38.3333 26.558 38.5089 26.134 38.8215 25.8215C39.134 25.5089 39.558 25.3333 40 25.3333ZM51.6667 25.3333H44.7C44 23.4 42.1667 22 40 22C37.8333 22 36 23.4 35.3 25.3333H28.3333C27.4493 25.3333 26.6014 25.6845 25.9763 26.3096C25.3512 26.9348 25 27.7826 25 28.6667V52C25 52.8841 25.3512 53.7319 25.9763 54.357C26.6014 54.9821 27.4493 55.3333 28.3333 55.3333H51.6667C52.5507 55.3333 53.3986 54.9821 54.0237 54.357C54.6488 53.7319 55 52.8841 55 52V28.6667C55 27.7826 54.6488 26.9348 54.0237 26.3096C53.3986 25.6845 52.5507 25.3333 51.6667 25.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2681_27672",
    x1: 0.375477,
    y1: -3.26288,
    x2: 74.6448,
    y2: 80.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFA73F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2681_27672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliacaoTelemed);
export default __webpack_public_path__ + "static/media/AvaliacaoTelemed.d09cbc98a9aa04efd4ad302c0149f96f.svg";
export { ForwardRef as ReactComponent };